import { memo } from 'react';
import t from 'common/i18n';
import { ComboboxItem, SimpleValueComboboxCreatableField } from '@cld/combobox';
import { ItemLayout } from '@clds/item';
import { Chip } from '@clds/chip';
import { Cross, TagSign } from '@clds/icon';
import Tooltip from '@clds/tooltip';
import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';

const convertOptionsToValues = (options) => {
  if (options.length) {
    return options.reduce((newValues, option) => {
      if (option !== '') {
        newValues.push({ value: option, label: option });
      }
      return newValues;
    }, []);
  } else {
    return [];
  }
};

const StyledCross = styled(Cross)`
  cursor: pointer;
  fill: currentColor;
`;

const StyledChip = styled(Chip)`
  margin: ${globalTheme.spacing.xxs};
  &:not(:nth-last-child(2)) {
    margin-right: 0;
    margin-bottom: 0;
  }
  max-width: calc(100% - ${globalTheme.spacing.xxs});
`;

const inputPlaceholder = () => (
  <div style={{ display: 'flex', gap: '8px' }}>
    <TagSign color="#90a0b3" />
    {t('advanced_options.tags_ph')}
  </div>
);

const TaggedInput = (props) => {
  const Option = (props) => (
    <ComboboxItem {...props}>
      <ItemLayout leftSlot={<TagSign size="md" color="secondary" />}>{props.data.label}</ItemLayout>
    </ComboboxItem>
  );
  const MultiValue = ({ data, removeProps }) => {
    return (
      <StyledChip
        className="bg-link bg-link-c"
        label={
          <Tooltip title={data.label} placement="top" maxWidth="md">
            <Tooltip.OverflowTrigger data-test="combobox-chip-value">{data.label}</Tooltip.OverflowTrigger>
          </Tooltip>
        }
        rightSlot={<StyledCross data-test="remove-chip" {...removeProps} size="xs" className="bg-link-c" />}
      />
    );
  };

  const replacedComponents = {
    DropdownIndicator: null,
    Option,
    MultiValue,
  };

  const convertedOptions = convertOptionsToValues([...props.suggestions]);

  return (
    <SimpleValueComboboxCreatableField
      menuPlacement="top"
      size="md"
      components={replacedComponents}
      options={convertedOptions}
      isSearchable
      isClearable
      isCreatable
      isMulti
      onChange={props.changeHandler}
      placeholder={inputPlaceholder()}
      formatCreateLabel={(label) => `${t('advanced_options.add_new')} '${label}'`}
      onInputChange={props.inputChangeHandler}
      value={props.values}
      backspaceRemovesValue
      className={'tags-input'}
    />
  );
};

export default memo(TaggedInput);
